// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__zWh00","header":"ReportDetails_header__3Sj8c","title":"ReportDetails_title__3uIFN","left":"ReportDetails_left__3VRtG"};